import { path } from "d3";

export const AxisBottomPath = ({
  xScale,
  innerHeight,
  tickOffset = 10,

  tickValue,

  tickValueMax,
  isSmallScreen,
}) => {
  const linePoints = [
    [xScale(tickValue), 0],
    [xScale(tickValue), innerHeight],
  ];

  const clipPathLine = path();
  clipPathLine.moveTo(...linePoints[0]);
  linePoints.slice(1).forEach((point) => clipPathLine.lineTo(...point));
  clipPathLine.closePath();
  return (
    <>
      {/* <text
        transform={`translate(${xScale(tickValue)},0)`}
        font-family="Poppins, sans-serif"
        style={{ textAnchor: "middle" }}
        fontSize={isSmallScreen ? 8 : 16}
        y={-tickOffset}
      >
        {tickValue}
      </text>*/}
      <path
        //stroke="#969595"
        stroke="#D3D3D3"
        strokeWidth="0.2"
        d={clipPathLine}
        clipPath={tickValue !== tickValueMax && "url(#clip-path)"}
      />
    </>
  );
};
